"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _OpportunitySummary = _interopRequireDefault(require("./OpportunitySummary"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The RfqSummary model module.
 * @module model/RfqSummary
 * @version 0.0.1
 */
var RfqSummary = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>RfqSummary</code>.
   * @alias module:model/RfqSummary
   */
  function RfqSummary() {
    _classCallCheck(this, RfqSummary);
    RfqSummary.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(RfqSummary, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>RfqSummary</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RfqSummary} obj Optional instance to populate.
     * @return {module:model/RfqSummary} The populated <code>RfqSummary</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new RfqSummary();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('label')) {
          obj['label'] = _ApiClient["default"].convertToType(data['label'], 'String');
        }
        if (data.hasOwnProperty('sent_ts')) {
          obj['sent_ts'] = _ApiClient["default"].convertToType(data['sent_ts'], 'Date');
        }
        if (data.hasOwnProperty('return_by_ts')) {
          obj['return_by_ts'] = _ApiClient["default"].convertToType(data['return_by_ts'], 'Date');
        }
        if (data.hasOwnProperty('received_ts')) {
          obj['received_ts'] = _ApiClient["default"].convertToType(data['received_ts'], 'Date');
        }
        if (data.hasOwnProperty('receiving_cage_code')) {
          obj['receiving_cage_code'] = _ApiClient["default"].convertToType(data['receiving_cage_code'], 'String');
        }
        if (data.hasOwnProperty('opportunities')) {
          obj['opportunities'] = _ApiClient["default"].convertToType(data['opportunities'], [_OpportunitySummary["default"]]);
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} id
 */
RfqSummary.prototype['id'] = undefined;

/**
 * @member {String} label
 */
RfqSummary.prototype['label'] = undefined;

/**
 * @member {Date} sent_ts
 */
RfqSummary.prototype['sent_ts'] = undefined;

/**
 * @member {Date} return_by_ts
 */
RfqSummary.prototype['return_by_ts'] = undefined;

/**
 * @member {Date} received_ts
 */
RfqSummary.prototype['received_ts'] = undefined;

/**
 * @member {String} receiving_cage_code
 */
RfqSummary.prototype['receiving_cage_code'] = undefined;

/**
 * @member {Array.<module:model/OpportunitySummary>} opportunities
 */
RfqSummary.prototype['opportunities'] = undefined;
var _default = exports["default"] = RfqSummary;